import { Row } from "antd";
import { MultiSelect } from "../../../../components/MultiSelect";
import {
  ACCOUNT_STATUSES,
  NEXT_PAYMENT_OPTIONS,
} from "../../../../lib/constants";
import { useCallback, useMemo } from "react";
import { useGetRole } from "../../../../lib/hooks/getRole";
import { AdminActions } from "./AdminActions";
import { SingleSelect } from "../../../../components/SingleSelect";
import { useSearchParams } from "react-router-dom";
import { SearchFilter } from "./SearchFilter";
import { RestrictionSelect } from "./RestictionSelect";
import { InfoCircleOutlined } from "@ant-design/icons";

type FiltersProps = {
  request: any;
  isLoading: boolean;
  isOther: boolean;
};

export const Filters = ({ request, isLoading, isOther }: FiltersProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, isAdmin] = useGetRole();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [__, setSearchParams] = useSearchParams();

  const accountStatuses: any[] = useMemo(() => {
    const value: any[] = structuredClone(ACCOUNT_STATUSES);

    return isAdmin
      ? value
      : value.filter((item: any) => ![4, 7].includes(item.value));
  }, [isAdmin]);

  const setStatuses = useCallback(
    (value: string[]) => {
      const params = { ...request, pageNumber: 1 };

      if (value[0] === "All") {
        delete params.statusFilter;
      } else {
        params.statusFilter = value;
      }

      setSearchParams(params);
    },
    [request, setSearchParams],
  );

  const setDateFilter = useCallback(
    (value: string | number) => {
      const params = { ...request, pageNumber: 1 };

      if (value === 0) {
        delete params["dateFilterNextPayment"];
      } else {
        params["dateFilterNextPayment"] = +value;
      }

      setSearchParams(params);
    },
    [request, setSearchParams],
  );

  return (
    <Row className="d-block w-100">
      <Row className="my-6">
        <h3 className="h h3">{isOther && "Other"} Accounts</h3>
      </Row>
      <Row className={`mb-4 ${isAdmin ? "justify-space-between" : ""}`}>
        <Row className="filters align-start">
          {!isOther && !isAdmin && (
            <>
              <Row className="mr-4">
                <MultiSelect
                  options={accountStatuses}
                  isLoading={isLoading}
                  onChange={setStatuses}
                  label="Status"
                  defaultValue={request.statusFilter || undefined}
                  maxTagCount={1}
                />
              </Row>
              <Row className="mr-4 mt-2">
                <InfoCircleOutlined className="text-secondary text-md mr-2" />
                <span className="text-secondary-2 text-sm">
                  Click on a row to open details
                </span>
              </Row>
            </>
          )}
          {isAdmin && (
            <>
              <Row className="mr-4 date-selector">
                <SearchFilter request={request} isLoading={isLoading} />
              </Row>
              {!isOther && (
                <>
                  <Row className="mr-4">
                    <MultiSelect
                      options={accountStatuses}
                      isLoading={isLoading}
                      onChange={setStatuses}
                      label="Status"
                      defaultValue={request.statusFilter || undefined}
                      maxTagCount={1}
                    />
                  </Row>
                  <Row className="mr-4 payment-select">
                    <SingleSelect
                      options={NEXT_PAYMENT_OPTIONS}
                      label="Next Payment"
                      value={+request.dateFilterNextPayment || 0}
                      onChange={setDateFilter}
                      loading={isLoading}
                      selectWidth={false}
                    />
                  </Row>
                  <RestrictionSelect request={request} isLoading={isLoading} />
                </>
              )}
            </>
          )}
        </Row>
        {isAdmin && <AdminActions request={request} isOther={isOther} />}
      </Row>
    </Row>
  );
};
